import React, { useCallback, useMemo, useState } from "react";
import data from "./data.json";
import Recommendations from "./components/Recommendations";
import QuestionDisplay from "./components/QuestionDisplay";
import Answers from "./components/Answers";
import RestartButton from "./components/RestartButton";
import { findMatchingRecommendations, getQuestionById } from "./utils/questionnaire";

const firstQuestionId = data.questions[0].questionId;

export default function Questionnaire(){
    const [currentQuestionId, setCurrentQuestionId] = useState(firstQuestionId);
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [finalRecommendations, setFinalRecommendations] = useState(null);
 
    const currentQuestion = useMemo(() => getQuestionById(data.questions, currentQuestionId), [currentQuestionId]);

    const handleAnswerClick = (answer) => {
        const newSelectedAnswers = [
            ...selectedAnswers,
            {
                questionId: currentQuestion.questionId,
                answerId: answer.answerId,
                answerText: answer.text,
            },
        ];

        setSelectedAnswers(newSelectedAnswers);

        if (answer.nextQuestionId) {
            setCurrentQuestionId(answer.nextQuestionId);
        } else {            
            const match = findMatchingRecommendations(data.recommendations, newSelectedAnswers.map((a) => a.answerId));

            setFinalRecommendations(match?.recommendations ?? []);
        }
    };

    const reset = useCallback(() => {
        setCurrentQuestionId(firstQuestionId);
        setSelectedAnswers([]);
        setFinalRecommendations(null);
    }, []);

    const removeAnswerByIndex = (index) => {
        const questionId = selectedAnswers[index]?.questionId;

        if (!questionId){
            return;
        }

        setSelectedAnswers(selectedAnswers.slice(0, index));
        setCurrentQuestionId(questionId);
        setFinalRecommendations(null);
    };

    if (finalRecommendations) {
        return (
            <>
                <RestartButton reset={reset} />

                <Recommendations
                    recommendations={finalRecommendations}
                />

                <p>Still not sure on blanketing or need help measuring your horse? Check out our <a href="https://www.smartpakequine.com/content/horse-blanket-guide">Ultimate Horse Blanketing Guide</a> for help deciding whether to blanket your horse, a handy blanketing temperature chart, tips on caring for your blankets, and more.</p>

                <Answers
                    selectedAnswers={selectedAnswers}
                    removeAnswerByIndex={removeAnswerByIndex}
                />
            </>
        );
    }

    return (
        <>
            {currentQuestionId !== firstQuestionId && <RestartButton reset={reset} />}     

            {currentQuestionId === firstQuestionId && (
                <header className="blanket-intro">
                    <h1>Take the SmartEquine Horse Blanket Quiz</h1>
                    <div className="h6">We&apos;ll ask you up to 5 questions to find your perfect Blanket. Let&apos;s get started! </div>
                </header>
            )}         
            
            <QuestionDisplay
                question={currentQuestion}
                onAnswerClick={handleAnswerClick}
            />

            {currentQuestionId === firstQuestionId && (
                <p>Blanketing isn&apos; t always a one-size-fits-all. Our horse blanket quiz makes it easy to match your horse&apos; s unique needs with the right blanket style and features. From extra durability for those tough on their blankets, to the right weight for your area&apos;s winter temperatures, and the best wither or neck style for optimal comfort and coverage, our quiz makes it simple. Answer a few quick questions and you&apos;ll get personalized horse blanket recommendations you can shop for right away. </p>
            )}

            <Answers
                selectedAnswers={selectedAnswers}
                removeAnswerByIndex={removeAnswerByIndex}
            />
        </>
    );
}

